module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ke-La.33cfac72.png";